// Missing configuration is checked before the providers start.

export const REQUIRED_ENV_VARS = ['VITE_API_BASE_URL'] as const

export type RequiredEnvVar = (typeof REQUIRED_ENV_VARS)[number]

export interface AppConfig {
  readonly apiBaseUrl: string
}

export type ConfigResult =
  | { readonly ok: true; readonly config: AppConfig }
  | { readonly ok: false; readonly missing: readonly RequiredEnvVar[] }

export type EnvSource = Readonly<Partial<Record<RequiredEnvVar, string>>>

// Remove trailing slashes before joining API paths.
function normaliseBaseUrl(value: string): string {
  return value.replace(/\/+$/, '')
}

export function readConfig(source: EnvSource): ConfigResult {
  const missing = REQUIRED_ENV_VARS.filter((name) => {
    const value = source[name]
    return typeof value !== 'string' || value.trim() === ''
  })

  if (missing.length > 0) {
    return { ok: false, missing }
  }

  return {
    ok: true,
    config: {
      apiBaseUrl: normaliseBaseUrl(source.VITE_API_BASE_URL!.trim()),
    },
  }
}

/** Read once at module load so every consumer sees the same answer. */
export const appConfig: ConfigResult = readConfig(import.meta.env)
